import PropTypes from 'prop-types';

const VolumeOffIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.738 19.578c1.472.958 2.44 2.581 2.44 4.422 0 2.761-2.178 5.032-4.969 5.306v16.862c0 .758-.45 1.453-1.157 1.706-.256.063-.45.126-.706.126-.457 0-.863-.15-1.218-.45l-.131-.118-10.739-11.319 16.48-16.535zm9.296-17.72.006.006a1.94 1.94 0 0 1 0 2.737L3.32 46.503a1.922 1.922 0 0 1-2.718.006l-.006-.006a1.94 1.94 0 0 1 0-2.737l41.72-41.902a1.922 1.922 0 0 1 2.718-.006zm-.31 12.309A16.344 16.344 0 0 1 48 23.991c0 3.558-1.144 6.967-3.277 9.824a2.197 2.197 0 0 1-1.716.852c-.417 0-.833-.15-1.197-.401-.936-.652-1.144-1.905-.468-2.807a12.449 12.449 0 0 0 2.497-7.468c0-2.707-.832-5.263-2.497-7.468-.676-.902-.468-2.156.468-2.807.937-.652 2.237-.451 2.913.451zM31.987.124c.656.235 1.09.85 1.201 1.494l.02.148-.001 3.646L6.1 32.615C2.531 31.272 0 27.869 0 23.873c0-5.053 4.047-9.159 9.121-9.348.052-.05.144-.06.245-.063H16.252L29.996.566c.514-.568 1.285-.695 1.991-.442z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

VolumeOffIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

VolumeOffIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default VolumeOffIcon;
